import { useEffect, useCallback } from 'react';

const TIMEOUT_MS = 60 * 60 * 1000;

const useAutoLogout = (isAuthenticated) => {
    const logout = useCallback(() => {
        if (isAuthenticated) {
            console.log("Inactividad detectada. Cerrando sesión...");
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if (!isAuthenticated) return;
        let timer;

        const resetTimer = () => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(logout, TIMEOUT_MS);
        };

        const events = ['load', 'mousemove', 'mousedown', 'keypress', 'scroll', 'click'];
        events.forEach(event => window.addEventListener(event, resetTimer));
        resetTimer();

        return () => {
            if (timer) clearTimeout(timer);
            events.forEach(event => window.removeEventListener(event, resetTimer));
        };
    }, [isAuthenticated, logout]);
};

export default useAutoLogout;